import { Typography } from '@mui/material'
import ZIcon from '../components/ZIcon'
import { AppropriatenessAssessmentFailIcon } from '../assets/icons'
import ZScreenContainer from '../components/ZScreenContainer'
import Header from '../components/Header'
import ZBottomContainer from '../components/ZBottomContainer'
import ZButton from '../components/ZButton'
import { canReturnToApp, returnToApp } from '../util/notifyHost'
import { SessionStorageKeys } from '../enums'

/**
 * Terminal: rejecting flips the user to REJECTED, so create fails until an
 * admin reset — hence no "resume the process" affordance.
 */
const AcceptanceRejected = ({ deepLinkURI }: { deepLinkURI?: string }) => {
  const authCode = sessionStorage.getItem(SessionStorageKeys.AuthCode)
  const canReturn = canReturnToApp(deepLinkURI)

  return (
    <ZScreenContainer>
      <Header title="Oh no!" />

      <ZIcon
        Icon={AppropriatenessAssessmentFailIcon}
        title="Appropriateness assessment fail icon"
      />

      <Typography>
        You&apos;ve chosen not to accept and complete the Financial Promotions
        process, so you have not passed and won&apos;t be able to invest in
        cryptoassets at this time.
        <br />
        <br />
        {canReturn
          ? 'Please press the button below to return to the app.'
          : 'You can now close this page and return to the app.'}
      </Typography>

      {canReturn ? (
        <ZBottomContainer>
          <ZButton onClick={() => returnToApp(authCode!, deepLinkURI)}>
            Return to the app
          </ZButton>
        </ZBottomContainer>
      ) : null}
    </ZScreenContainer>
  )
}

export default AcceptanceRejected
